import { Orientation } from '@/modules'
import * as PIXI from 'pixi.js'
import Facade from '../../Facade'
import GeneralSignals from '../../signals/GeneralSignals'

export class ApplicationResizer {
    protected readonly _viewWrapper: HTMLDivElement
    protected readonly _canvas: HTMLCanvasElement

    protected _wrapperBounds: PIXI.Rectangle
    protected _gameStageBounds: PIXI.Rectangle
    protected _orientation: Orientation

    public constructor(canvas: HTMLCanvasElement, viewWrapper: HTMLDivElement) {
        this._viewWrapper = viewWrapper
        this._canvas = canvas

        this._gameStageBounds = new PIXI.Rectangle()
        this._orientation = this.detectOrientation()
        this._wrapperBounds = new PIXI.Rectangle()

        this.updateGameStageBounds()
        this.updateWrapperBounds()
    }

    protected detectOrientation(): Orientation {
        return Orientation.LANDSCAPE
    }

    protected updateGameStageBounds(): void {
        this._gameStageBounds.height = 0
        this._gameStageBounds.width = 0
    }

    public updateWrapperBounds(): void {
        this._wrapperBounds.height = 0
        this._wrapperBounds.width = 0
    }

    public isSizeChanged(): boolean {
        const { width, height } = this._wrapperBounds
        this.updateWrapperBounds()

        if (width !== this._wrapperBounds.width || height !== this._wrapperBounds.height) {
            return true
        }

        return false
    }

    public updateCanvasSize(): void {
        const { canvasWidth, canvasHeight } = this
        const { width, height } = this._gameStageBounds

        // PixiJS v8: resolution is set during Application creation and is readonly
        // Check if renderer exists before calling resize
        if (Facade.app && Facade.app.renderer) {
            Facade.app.renderer.resize(canvasWidth, canvasHeight)
        }

        if (Facade.container) {
            if (this._orientation === Orientation.LANDSCAPE) {
                Facade.container.position.set(1065, 445.5)
            } else {
                Facade.container.position.set(550, 930)
            }
        }
    }

    public updateSize(force: boolean = false): void {
        const orientation = this.detectOrientation()

        if (force || this._orientation !== orientation) {
            Facade.orientation = this._orientation = orientation
            this.updateGameStageBounds()
            GeneralSignals.orientationChanged.emit(orientation)
        }

        this.updateCanvasSize()
    }

    public get stageHeight(): number {
        return this._gameStageBounds.height
    }

    public get stageWidth(): number {
        return this._gameStageBounds.width
    }

    public get canvasHeight(): number {
        return 0
    }

    public get canvasWidth(): number {
        return 0
    }

    public get orientation(): Orientation {
        return this._orientation
    }

    public get resolution(): number {
        return 1
    }
}
